import { IAction } from 'redhotpie-shared-lib/interfaces/IAction';
import * as types from '../constants/actionTypes';
import initialState from './initialState';
import { ImmutableObject } from 'seamless-immutable';
import {
  IAddPaymentOption,
  ICurrency,
  INonSubscriptionProduct,
  IProduct,
  IPurchaseCredit,
  IStoreCredits,
  IVerote,
} from 'redhotpie-shared-lib/interfaces/IPayment';
// import * as CONSTANTS from '../constants/constants';
// import { IPurchaseCredit } from 'redhotpie-shared-lib/interfaces/IPayment';
// import { IStoreCredits } from '../interfaces/IPayment';

export interface IPaymentGatewayState {
  additionalPaymentOptions?: IAddPaymentOption;
  currency?: ICurrency;
  isPaymentAvailable: boolean;
  paymentOptions: any[];
  products: IProduct[];
  nonSubscriptionProducts: INonSubscriptionProduct[];
  userDiscount: string;
  costSelected: any;
  typeProductSelected: number;
  diamonds: number;
  isExistsCreditCard: boolean;
  productOptions: any[];
  purchaseToken: string;
  diamondsBalance: number;
  coinCredits: any[];
  storeCredits: IStoreCredits[];
  currentStoreCredits: number;
  currentConversationCredits: number;
  conversationCredits: IPurchaseCredit[];
  upgradePath: string;
  verotePaymentOptions?: IVerote;
  highestCoinUnitPrice: number;
}

export default function paymentGatewayReducer(state: ImmutableObject<IPaymentGatewayState> = initialState.paymentGateway, action: IAction) {
  switch (action.type) {
    case types.UPDATE_STATE_PAYMENT_GATEWAY:
      return state.merge({ ...action.data });
    case types.GET_PAYMENT_SUCCESS:
      return state.merge({ ...action.data.data });
    case types.UPDATE_DIAMONDS:
      return state.merge({ diamonds: action.newDiamond });
    default:
      return state;
  }
}
